import { useState, useEffect } from 'react';
import ToggleForm from '../../../components/toggle/ToggleForm';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

const defaultProps = {
  profile: {},
  onChangeCallback: () => {},
};

const RedXPrompting = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { profile, onChangeCallback } = mergedProps;
  const [toggle, setToggle] = useState(profile.prompt);
  const isRedXPrompting = profile.prompt;
  // When mounting and changing a profile.
  useEffect(() => {
    setToggle(isRedXPrompting);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.id]);

  const handleRedXPromptingOnchange = (field, newValue) => {
    if (newValue === null) return;
    setToggle(newValue);
    onChangeCallback(newValue);
  };

  return (
    <ToggleForm value={toggle} handleOnChange={handleRedXPromptingOnchange} />
  );
};

export default RedXPrompting;
